/**
 * shared-worklist-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../general";
import { MessageTag } from "../message-tag";

export class SharedWorklistRequest extends ReplyVerifyingMessage
{
	/** The unique tag for this message type */
	public tag : MessageTag = MessageTag.REQ_SHARED_WORKLIST;
	public static tag : MessageTag = MessageTag.REQ_SHARED_WORKLIST;

	/**
	 * Construct a new {@link CreateGroupRequest}.
	 */
	constructor (
		public groupId : number,
		public opaqueId? : number,
		public stablePath? : string
	)
	{
		super();
	}

	public verifyReply (reply : Message) : boolean
	{
		return Message.isA(reply, MessageTag.RSP_WATCHLIST);
	}
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/shared-worklist-request.ts